<template>
  <transition name="modal-fade">
    <div v-if="show" class="policy-modal-overlay" @click.self="$emit('close')">
      <div class="policy-modal" :class="{ 'is-mobile': isMobile }">
        <!-- Header -->
        <div class="policy-modal-header">
          <h2 class="policy-modal-title">{{ title }}</h2>
          <button type="button" class="policy-modal-close" @click="$emit('close')">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Body -->
        <div class="policy-modal-body">
          <slot></slot>
        </div>

        <!-- Footer -->
        <div class="policy-modal-footer">
          <button type="button" class="policy-modal-btn" @click="$emit('close')">
            Close
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PolicyModal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isMobile: false
    }
  },

  watch: {
    show(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },

  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    document.body.style.overflow = ''
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    }
  }
}
</script>

<style scoped>
/* Overlay */
.policy-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

/* Modal - Desktop */
.policy-modal {
  background: #fff;
  border-radius: 16px;
  max-width: 700px;
  width: 100%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

/* Modal - Mobile (Bottom Sheet) */
.policy-modal.is-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  max-height: 90vh;
  border-radius: 20px 20px 0 0;
  margin: 0;
  overflow: hidden;
}

/* Mobile overlay - no horizontal padding */
@media (max-width: 768px) {
  .policy-modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .policy-modal-body {
    padding: 20px 16px;
  }

  .policy-modal-footer {
    padding: 12px 16px;
  }
}

/* Header */
.policy-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.policy-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.policy-modal-close {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 8px;
  transition: all 0.2s;
}

.policy-modal-close:hover {
  background: #f3f4f6;
  color: #1f2937;
}

/* Body */
.policy-modal-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px;
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.policy-modal-body a {
  word-break: break-all;
}

/* Footer */
.policy-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.policy-modal-btn {
  width: 100%;
  padding: 14px 24px;
  background: #08466f;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.policy-modal-btn:hover {
  background: #063a5a;
}

/* Transitions */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-active .policy-modal,
.modal-fade-leave-active .policy-modal {
  transition: transform 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter .policy-modal,
.modal-fade-leave-to .policy-modal {
  transform: translateY(20px);
}

.modal-fade-enter .policy-modal.is-mobile,
.modal-fade-leave-to .policy-modal.is-mobile {
  transform: translateY(100%);
}

/* Content Styles */
.policy-modal-body h2 {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  margin: 24px 0 12px 0;
}

.policy-modal-body h2:first-child {
  margin-top: 0;
}

.policy-modal-body h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 20px 0 10px 0;
}

.policy-modal-body p {
  margin: 0 0 12px 0;
}

.policy-modal-body ul {
  margin: 0 0 16px 0;
  padding-left: 20px;
}

.policy-modal-body li {
  margin-bottom: 8px;
}

.policy-modal-body strong {
  color: #1f2937;
}

.policy-modal-body .last-updated {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 20px;
}
</style>
